"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Thumbnail =
/** @class */
function (_super) {
  __extends(Thumbnail, _super);

  function Thumbnail(props) {
    var _this = _super.call(this, props) || this;

    _this._loaded = false;
    _this._img = react_1.default.createRef();
    _this.state = {
      hover: false
    };
    _this.loadMaybe = _this.loadMaybe.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);

    _this.props.events.on("thumbnail:check", _this.loadMaybe);

    return _this;
  }

  Thumbnail.prototype.loadMaybe = function () {
    if (this._loaded || !this._img.current) {
      return;
    }

    if (this._img.current.offsetParent.offsetTop < window.innerHeight + window.pageYOffset) {
      this._img.current.src = this._img.current.dataset.src;
      this.props.events.removeListener("thumbnail:check", this.loadMaybe);
      this._loaded = true;
    }
  };

  Thumbnail.prototype.tileViewportStyle = function () {
    if (this.props.tileViewportStyle) return this.props.tileViewportStyle.call(this);
    return {
      width: this.props.vWidth,
      height: this.props.height,
      overflow: "hidden"
    };
  };

  Thumbnail.prototype.thumbnailStyle = function () {
    if (this.props.thumbnailStyle) return this.props.thumbnailStyle.call(this);
    var rotationTransformValue;

    switch (this.props.orientation) {
      case 3:
        rotationTransformValue = "rotate(180deg)";
        break;

      case 6:
        rotationTransformValue = "rotate(90deg)";
        break;

      case 8:
        rotationTransformValue = "rotate(270deg)";
        break;

      case 2:
        rotationTransformValue = "rotateY(180deg)";
        break;

      case 4:
        rotationTransformValue = "rotate(180deg) rotateY(180deg)";
        break;

      case 5:
        rotationTransformValue = "rotate(270deg) rotateY(180deg)";
        break;

      case 7:
        rotationTransformValue = "rotate(90deg) rotateY(180deg)";
        break;
    }

    return {
      cursor: "pointer",
      width: this.props.width,
      height: this.props.height,
      marginLeft: this.props.marginLeft,
      marginTop: 0,
      transform: rotationTransformValue
    };
  };

  Thumbnail.prototype.handleClick = function (e) {
    var _a = this.props,
        onClick = _a.onClick,
        index = _a.index;

    if (onClick) {
      onClick({
        src: this.props.src,
        height: this.props.height,
        width: this.props.width
      }, index, e);
    }
  };

  Thumbnail.prototype.render = function () {
    var _this = this;

    var alt = this.props.alt || "";
    return react_1.default.createElement("div", {
      onMouseEnter: function onMouseEnter() {
        return _this.setState({
          hover: true
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this.setState({
          hover: false
        });
      },
      style: {
        margin: this.props.margin,
        display: "inline",
        userSelect: "none",
        position: "relative",
        background: "#eee",
        padding: "0px"
      }
    }, react_1.default.createElement("div", {
      style: {
        cursor: "pointer",
        position: "absolute",
        height: "100%",
        width: "100%",
        pointerEvents: "none",
        opacity: 1,
        background: this.state.hover ? "linear-gradient(to bottom,rgba(0,0,0,0.26),transparent 56px,transparent)" : "none"
      }
    }), react_1.default.createElement("div", {
      style: this.tileViewportStyle(),
      onClick: this.handleClick
    }, react_1.default.createElement("img", {
      ref: this._img,
      "data-src": this.props.src,
      alt: alt,
      style: this.thumbnailStyle()
    })));
  };

  return Thumbnail;
}(react_1.default.PureComponent);

exports.default = Thumbnail;